const HEX_VALUES = {
  blue: ['#49607c'],
  black: ['#3b3b3b'],
  pink: ['#dfabb5'],
  beige: ['#b9afa1'],
  grey: ['#8c8c8c'],
  white: ['#f5f4f0'],
  red: ['#b14754'],
  yellow: ['#ead99a'],
  green: ['#69715e'],
  purple: ['#bbb9d5'],
  orange: ['#fbb365'],
  brown: ['#bd9474'],
  'multi-color': ['#bd9474', '#779ecb', '#bbb9d5'],
};

export { HEX_VALUES };

export default HEX_VALUES;
